import {
	Column,
	CreateDateColumn,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { ClientLicenseMatchEntity } from './client-license-match.entity';

export type ClientLicenseMatchLogAction =
	| 'created'
	| 'confirmed'
	| 'rejected'
	| 'reverted'
	| 'confidence_updated';

/**
 * Audit log for client_license_match status and confidence changes.
 * Does NOT extend BaseEntity — lightweight log table with minimal columns.
 */
@Index('idx_clml_match', ['fkClientLicenseMatchId'])
@Entity('client_license_match_log')
export class ClientLicenseMatchLogEntity {
	@PrimaryGeneratedColumn({ name: '_id', unsigned: true })
	public id!: number;

	@Column('int', {
		name: 'fk_client_license_match__id',
		unsigned: true,
	})
	public fkClientLicenseMatchId!: number;

	@Column('enum', {
		name: 'action',
		enum: [
			'created',
			'confirmed',
			'rejected',
			'reverted',
			'confidence_updated',
		],
	})
	public action!: ClientLicenseMatchLogAction;

	@Column('varchar', { name: 'old_status', nullable: true, length: 50 })
	public oldStatus!: string | null;

	@Column('varchar', { name: 'new_status', nullable: true, length: 50 })
	public newStatus!: string | null;

	@Column('decimal', {
		name: 'old_confidence',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public oldConfidence!: string | null;

	@Column('decimal', {
		name: 'new_confidence',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public newConfidence!: string | null;

	@Column('int', { name: 'user_id', nullable: true, unsigned: true })
	public userId!: number | null;

	@Column('varchar', { name: 'note', nullable: true, length: 1000 })
	public note!: string | null;

	@CreateDateColumn({
		name: '_created_date',
		nullable: false,
		precision: 0,
		default: () => 'CURRENT_TIMESTAMP',
	})
	public createdDate!: Date;

	@ManyToOne(() => ClientLicenseMatchEntity, (match) => match.logs, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: 'fk_client_license_match__id', referencedColumnName: 'id' },
	])
	public fkClientLicenseMatch!: ClientLicenseMatchEntity;
}
